import { module } from "angular";
import core from "@gtmhub/core/module";
import employeesCore from "@gtmhub/employees/employees-core.module";
import favorites from "@gtmhub/favorites/favorites.module";
import insightsCore from "@gtmhub/insights/insights-core.module";
import onboardingCore from "@gtmhub/onboarding/onboarding-core.module";
import pluginsCore from "@gtmhub/plugins/plugins-core.module";
import searchCore from "@gtmhub/search/search-core.module";
import sessionsCore from "@gtmhub/sessions/sessions-core.module";
import dndList from "@gtmhub/shared/components/dnd-list/dnd-list.module";
import gridFilteringBar from "@gtmhub/shared/components/grid-filtering-bar/grid-filtering-bar.module";
import ngExtensions from "@gtmhub/shared/ng-extensions/ng-extensions.module";
import teamsCore from "@gtmhub/teams/teams-core.module";
import { RelatedItemsComponent } from "@webapp/links/components/related-items-component/related-items.component";
import { OkrMetricBarBooleanComponent } from "@webapp/okrs/components/metric-bar/metric-bar-boolean/okr-metric-bar-boolean.component";
import { OkrMetricBarProgressComponent } from "@webapp/okrs/components/metric-bar/metric-bar-progress/okr-metric-bar-progress.component";
import { OkrMetricBarTargetComponent } from "@webapp/okrs/components/metric-bar/metric-bar-target/okr-metric-bar-target.component";
import { OkrContributorsComponent } from "@webapp/okrs/components/okr-contributors/okr-contributors.component";
import { OkrTasksComponent } from "@webapp/okrs/components/okr-tasks/okr-tasks.component";
import { OkrWorkflowComponent } from "@webapp/okrs/components/okr-workflow/okr-workflow.component";
import { ParentSelectorComponent } from "@webapp/okrs/components/parent-selector/parent-selector.component";
import { SectionTitleWithIconComponent } from "@webapp/okrs/components/section-title-with-icon/section-title-with-icon.component";
import { OkrAttainmentPickerComponent } from "@webapp/okrs/goals/components/attainment-picker/attainment-picker.component";
import { GoalsBulkDeleteComponent } from "@webapp/okrs/goals/components/goals-bulk-delete/goals-bulk-delete.component";
import { MetricContributorDropdownComponent } from "@webapp/okrs/metrics/components/metric-contributor-dropdown/metric-contributor-dropdown.component";
import { PluginsComponent } from "@webapp/plugins/components/plugins/plugins.component";
import { SessionSelectorComponent } from "@webapp/sessions/shared/components/session-selector/session-selector.component";
import { ConfidenceLabelComponent } from "@webapp/shared/components/confidence-label/confidence-label.component";
import { UiDropdownMenuComponent } from "@webapp/ui/dropdown/components/dropdown-menu/dropdown-menu.component";
import { BulkTagComponent } from "./components/bulk-tag/bulk-tag.component";
import { ContributorComponent } from "./components/contributor/contributor.component";
import { CreateFirstGoalFormComponent } from "./components/create-first-goal-form.component";
import { MetricBarBooleanComponent } from "./components/metric-bar-boolean/metric-bar-boolean.component";
import { MetricBarProgressComponent } from "./components/metric-bar-progress/metric-bar-progress.component";
import { MetricBarTargetComponent } from "./components/metric-bar-target/metric-bar-target.component";
import { OkrGridContributorsComponent } from "./components/okr-grid-contributors/okr-grid-contributors.component";
import { OkrTasksComponent as Ng1OkrTasksComponent } from "./components/okr-tasks/okr-tasks.component";
import { OkrWorkflowComponent as Ng1OkrWorkflowComponent } from "./components/okr-workflow/okr-workflow.component";
import quantivePlusModule from "./components/quantive-plus/quantive-plus.module";
import { GoalSelectorNodeComponent } from "./components/single-goal-selector/goal-selector-node.component";
import { SingleGoalSelectorGoalsListComponent } from "./components/single-goal-selector/single-goal-selector-goals-list.component";
import { SingleGoalSelectorMetricsListComponent } from "./components/single-goal-selector/single-goal-selector-metrics-list.component";
import { SingleGoalSelectorSessionRowComponent } from "./components/single-goal-selector/single-goal-selector-session-row.component";
import { SingleGoalSelectorComponent } from "./components/single-goal-selector/single-goal-selector.component";
import { AllGoalsCtrl } from "./controllers/all";
import { BulkAssignCtrl } from "./controllers/bulk-assign";
import { CloneOrMoveGoalCtrl } from "./controllers/clone-or-move-goal";
import { EditGoalCtrl } from "./controllers/form";
import { GoalCtrl } from "./controllers/goal";
import { GoalTimelineCtrl } from "./controllers/goal-timeline";
import { GoalsCtrl } from "./controllers/goals";
import { ReviewCtrl } from "./controllers/review";
import { SendForApprovalCtrl } from "./controllers/send-for-approval";
import { SubmitToMarketplaceCtrl } from "./controllers/submit-to-marketplace";
import { GoalListNode } from "./directives/goal-list-node";
import { booleanUpdateValue } from "./filters/boolean-update-value.filter";
import { localizeGridColName } from "./filters/localize-grid-col-name.filter";
import goalsCore from "./goals-core.module";
import { GoalsTreeService } from "./services/goals-tree.service";
import { PolicyService } from "./services/policy.service";
import { Timeline } from "./timeline/timeline.directive";
import { TimelineService } from "./timeline/timeline.service";

const mod = module("goals", [
  core,
  goalsCore,
  onboardingCore,
  sessionsCore,
  insightsCore,
  ngExtensions,
  dndList,
  pluginsCore,
  gridFilteringBar,
  quantivePlusModule,
  employeesCore,
  teamsCore,
  searchCore,
  favorites,
]);

mod.controller("AllGoalsCtrl", AllGoalsCtrl);
mod.controller("BulkAssignCtrl", BulkAssignCtrl);
mod.controller("CloneOrMoveGoalCtrl", CloneOrMoveGoalCtrl);
mod.controller("EditGoalCtrl", EditGoalCtrl);
mod.controller("GoalCtrl", GoalCtrl);
mod.controller("GoalsCtrl", GoalsCtrl);
mod.controller("GoalTimelineCtrl", GoalTimelineCtrl);
mod.controller("ReviewCtrl", ReviewCtrl);
mod.controller("SendForApprovalCtrl", SendForApprovalCtrl);
mod.controller("SubmitToMarketplaceCtrl", SubmitToMarketplaceCtrl);

mod.service("GoalsTreeService", GoalsTreeService);
mod.service("TimelineService", TimelineService);
mod.service("PolicyService", PolicyService);

mod.directive("goalListNode", GoalListNode.factory());
mod.downgradeComponent("relatedItems", { component: RelatedItemsComponent, propagateDigest: false });
mod.downgradeComponent("goalsBulkDelete", { component: GoalsBulkDeleteComponent, propagateDigest: false });
mod.downgradeComponent("ghSessionSelector", { component: SessionSelectorComponent, propagateDigest: false });
mod.directive("timeline", Timeline.factory());
mod.downgradeComponent("parentSelector", { component: ParentSelectorComponent, propagateDigest: false });
mod.downgradeComponent("sectionTitleWithIcon", { component: SectionTitleWithIconComponent, propagateDigest: false });
mod.downgradeComponent("metricContributorDropdown", { component: MetricContributorDropdownComponent, propagateDigest: false });
mod.downgradeComponent("ghOkrWorkflow", { component: OkrWorkflowComponent, propagateDigest: false });
mod.downgradeComponent("ghOkrTasks", { component: OkrTasksComponent, propagateDigest: false });
mod.downgradeComponent("okrMetricBarProgress", { component: OkrMetricBarProgressComponent, propagateDigest: false });
mod.downgradeComponent("okrMetricBarBoolean", { component: OkrMetricBarBooleanComponent, propagateDigest: false });
mod.downgradeComponent("okrMetricBarTarget", { component: OkrMetricBarTargetComponent, propagateDigest: false });
mod.downgradeComponent("okrContributors", { component: OkrContributorsComponent, propagateDigest: false });
mod.downgradeComponent("confidenceLabel", { component: ConfidenceLabelComponent, propagateDigest: false });
mod.downgradeComponent("ghPlugins", { component: PluginsComponent, propagateDigest: false });
mod.downgradeComponent("uiDropdownMenu", { component: UiDropdownMenuComponent, propagateDigest: false });
mod.downgradeComponent("okrAttainmentPicker", { component: OkrAttainmentPickerComponent, propagateDigest: false });

mod.component("singleGoalSelector", SingleGoalSelectorComponent);
mod.component("singleGoalSelectorGoalsList", SingleGoalSelectorGoalsListComponent);
mod.component("singleGoalSelectorMetricsList", SingleGoalSelectorMetricsListComponent);
mod.component("singleGoalSelectorSessionRow", SingleGoalSelectorSessionRowComponent);
mod.component("goalSelectorNode", GoalSelectorNodeComponent);
mod.component("createFirstGoalForm", CreateFirstGoalFormComponent);
mod.component("contributor", ContributorComponent);
mod.component("metricBarTarget", MetricBarTargetComponent);
mod.component("metricBarBoolean", MetricBarBooleanComponent);
mod.component("metricBarProgress", MetricBarProgressComponent);
mod.component("okrGridContributors", OkrGridContributorsComponent);
mod.component("bulkTag", BulkTagComponent);
mod.component("okrTasks", Ng1OkrTasksComponent);
mod.component("okrWorkflow", Ng1OkrWorkflowComponent);

mod.filter("localizeGridColName", localizeGridColName);
mod.filter("booleanUpdateValue", booleanUpdateValue);

export default mod.name;
